import React, { useState } from 'react';
import './HomeVideoSection.css';
import VideoModal from '../VideoModal';
import playIcon from './assets/svg/status-play.svg';

function HomeVideoSection() {
  const [videoOpen, setVideoOpen] = useState(false);

  return (
    <section className="home-video-section">
      {videoOpen && <VideoModal onClose={() => setVideoOpen(false)} />}
      <div className="video-wrapper">
        <div
          className="video-placeholder"
          onClick={() => setVideoOpen(true)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") setVideoOpen(true); }}
          style={{ cursor: "pointer" }}
        >
          <img src={playIcon} alt="Play" className="play-icon" style={{ pointerEvents: "none" }} />
        </div>
      </div>
    </section>
  );
}

export default HomeVideoSection;